import { qsa } from '@fluorescent/dom';
import { section } from '@/neon';

import { backgroundVideoHandler } from '@/lib/a11y';
import scrollIntoView from '@/lib/scrollIntoView';

const selectors = {
  gridItem: '.mosaic-grid__item',
  video: '.mosaic-grid__item-video',
};

section('mosaic-grid-2-column', {
  onLoad() {
    const videos = qsa(selectors.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(video => {
        this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }

    this.scrollAnimation = scrollIntoView(
      this.container,
      qsa(selectors.gridItem, this.container)
    );
  },

  onUnload() {
    this.videoHandlers.forEach(handler => handler());
    this.scrollAnimation.unload();
  },
});
